export default function (start: string, end: string) {
  return `${useFormatDate('time', start)} – ${useFormatDate('time', end)}`
}
